import React, { createContext, useState, useContext, useEffect } from 'react';
import { 
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  onAuthStateChanged
} from 'firebase/auth';
import { auth } from '../firebase';

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  const [currentUser, setCurrentUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [networkError, setNetworkError] = useState(false);

  async function checkAdminStatus(user) {
    if (!user) {
      setIsAdmin(false);
      return;
    }
    
    // Set admin status for your email
    if (user.email === 'dan.burnip@gmail.com') {
      setIsAdmin(true);
      return;
    }
    
    setIsAdmin(false);
  }

  async function signup(email, password) {
    try {
      setNetworkError(false);
      const result = await createUserWithEmailAndPassword(auth, email, password);
      return result;
    } catch (error) {
      console.error('Signup error:', error); // Log the full error
      if (error.code === 'auth/network-request-failed') {
        setNetworkError(true);
      }
      throw error; // Throw the original error to preserve the error code
    }
  }

  async function login(email, password) {
    try {
      setNetworkError(false);
      const result = await signInWithEmailAndPassword(auth, email, password);
      return result;
    } catch (error) {
      console.error('Login error:', error); // Log the full error
      if (error.code === 'auth/network-request-failed') {
        setNetworkError(true);
      }
      throw error; // Throw the original error to preserve the error code
    }
  }

  async function logout() {
    try {
      setNetworkError(false);
      await signOut(auth);
    } catch (error) {
      console.error('Logout error:', error); // Log the full error
      if (error.code === 'auth/network-request-failed') {
        setNetworkError(true);
      }
      throw error; // Throw the original error to preserve the error code
    }
  }

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      try {
        setCurrentUser(user);
        await checkAdminStatus(user);
        setNetworkError(false);
      } catch (error) {
        console.error('Auth state change error:', error);
        if (error.code === 'auth/network-request-failed') {
          setNetworkError(true);
        }
      } finally {
        setLoading(false);
      }
    });

    return unsubscribe;
  }, []);

  const value = {
    currentUser,
    isAdmin,
    networkError,
    login,
    signup,
    logout,
  };

  return (
    <AuthContext.Provider value={value}>
      {!loading && children}
    </AuthContext.Provider>
  );
} 